import styled, { keyframes } from 'styled-components';
import { MdClose } from 'react-icons/md';

const changeOpacity = keyframes`
  0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
`;

const offerShine = keyframes`
  // 100% {
  //   transform: translateX(480px) skewX(-20deg);
  // }
  100%{
  left: 120%;
  }
`;

export const Container = styled.div`
  z-index: 2000;
  position: ${(props) => (props.checkout ? 'relative' : 'sticky')};
  height: var(--topOfferSnackbarHeight);
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  // background: linear-gradient(to right, #24243e, #302b63, #0f0c29);
  background: ${(props) => (props.background ? props.background : 'var(--goldenBgColor)')};
  animation: 1.5s linear 0s 1 ${changeOpacity};
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const StripedContainer = styled.div`
  z-index: 2000;
  position: ${(props) => (props.checkout ? 'relative' : 'sticky')};
  left: 0;
  bottom: 0;
  width: 100%;
  height: var(--topOfferSnackbarHeight);
  padding: 0px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  animation: 1.5s linear 0s 1 ${changeOpacity};
  background-color: ${({ variant }) => (variant === 'regionals' ? 'var(--regionalsBarBg)' : 'var(--brandColor)')};
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ variant }) => (variant === 'regionals' ? 'var(--stripedRegionalsLightBg)' : 'var(--stripedBlueBg)')};
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const Content = styled.div`
  text-align: center;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px;
    font-size: 12px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  @media (min-width: 576px) {
    padding: 7px;
  }
  @media (min-width: 768px) {
    padding: 10px;
  }
`;

export const InfoContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: 5px;
  column-gap: 5px;
  padding-left: 7px;
  font-size: 14px;
  @media (min-width: 576px) {
    padding-left: 0px;
  }
  @media (min-width: 768px) {
    column-gap: 15px;
  }
`;

export const AvailNowButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  padding: 4px 40px;
  color: #212121;
  background: #ffd300;
  :hover {
    background: #fff80a;
  }
  @media (min-width: 576px) {
    padding: 3px 8px;
  }
  @media (min-width: 768px) {
    padding: 4px 12px;
  }
`;

export const CloseButton = styled(AvailNowButton)`
  border-radius: 0;
  min-width: 100px;
  color: #fff;
  background: transparent;
`;

export const CloseIcon = styled(MdClose)`
  margin: 0px 7px;
  align-self: flex-start;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  :hover {
    color: #cee5d0;
  }
  @media (min-width: 576px) {
    align-self: unset;
  }
`;

export const InfoBarWrapper = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  padding: 10px;
  padding-right: ${(props) => props.closeIcon && '20px'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoBarActionButton = styled.a`
  font-size: 14px;
  color: ${(props) => (props.txtColor ? props.txtColor : 'white')} important;
  background: none;
  text-decoration: underline !important;
  margin-left: 8px;
  :hover {
    opacity: 0.8;
    text-decoration: underline !important;
  }
  @media (min-width: 320px) {
    padding: 4px 12px;
    border-radius: 4px;
    font-weight: 600;
    color: var(--inputTxtColor) !important;
    background: var(--goldenBgColor);
    text-decoration: none !important;
    :hover {
      background: #ffd300;
      color: #000 !important;
      text-decoration: none !important;
    }
  }
  @media (min-width: 481px) {
    padding: 5px 15px;
    font-size: 15px;
  }
  @media (min-width: 576px) {
    margin-left: 16px;
  }
`;

const clipping = keyframes`
  0% {
    -webkit-clip-path: polygon(0 0, 100% 0%, 100% 0, 0 0);
    clip-path: polygon(0 0, 100% 0%, 100% 0, 0 0);
    opacity: 1;
  }
  100% {
    -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%);
  }
`;

// course special offer snackbar starts
export const TopInfoBar = styled.div`
  z-index: 1100;
  position: sticky;
  top: ${(props) => (props.trialSnackbar ? 'var(--trialSnackbarHeight)' : '0px')};
  left: 0px;
  width: 100%;
  height: var(--topOfferSnackbarHeight);
  padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : props.oneTimeOffer ? '0px 4px' : '0px 8px')};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.background ? props.background : 'var(--goldenBgColor)')};
  overflow: hidden;
  box-shadow: 0px 1px 4px var(--greyShadowColor);
  animation: ${clipping} 1s ease;
  @media (min-width: 481px) {
    padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : props.oneTimeOffer ? '0px 8px' : '0px 16px')};
  }
  @media (min-width: 576px) {
    padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : '0px 20px')};
  }
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const StripedTopInfoBar = styled.div`
  z-index: 1100;
  position: sticky;
  top: ${(props) => (props.trialSnackbar ? 'var(--trialSnackbarHeight)' : '0px')};
  left: 0px;
  height: var(--topOfferSnackbarHeight);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : props.oneTimeOffer ? '0px 4px' : '0px 8px')};
  overflow: hidden;
  box-shadow: 0px 1px 4px var(--greyShadowColor);
  background-color: ${({ variant }) => (variant === 'regionals' ? 'var(--regionalsBarBg)' : 'var(--brandColor)')};
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ variant }) => (variant === 'regionals' ? 'var(--stripedRegionalsLightBg)' : 'var(--stripedBlueBg)')};
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
  animation: ${clipping} 1s ease;
  @media (min-width: 481px) {
    padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : props.oneTimeOffer ? '0px 8px' : '0px 16px')};
  }
  @media (min-width: 576px) {
    padding: ${(props) => (props.closeIcon ? '0px 20px 0px 0px' : '0px 20px')};
  }
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

// old wrapper
export const TopInfoBarWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  height: 100%;
  padding-left: 10px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
  @media (min-width: 360px) {
    padding-left: 20px;
  }
  @media (min-width: 576px) {
    flex-direction: row-reverse;
    column-gap: 32px;
  }
  @media (min-width: 992px) {
    padding-left: unset;
    flex-direction: row;
  }
`;

// new wrapper
export const InfoBarContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  height: 100%;
  padding-left: 10px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
  @media (min-width: 360px) {
    padding-left: 20px;
  }
  @media (min-width: 576px) {
    flex-direction: row-reverse;
    column-gap: 32px;
  }
  @media (min-width: 992px) {
    padding-left: unset;
    flex-direction: row;
  }
`;

// oneTimeOffer wrapper
export const OfferContentOuter = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  height: 100%;
  margin: 0px auto;
  display: grid;
  align-items: center;
  cursor: pointer;
  @media (min-width: 576px) {
    grid-template-columns: max-content auto;
    justify-content: center;
  }
`;

export const OfferIconWrapper = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  @media (min-width: 481px) {
    margin-right: 12px;
  }
`;

export const OfferBarTimerWrapper = styled.div`
  display: block;
  width: fit-content;
  cursor: pointer;
`;

export const InfoBarIconWrapper = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: grid;
    place-items: center;
    height: 40px;
    width: 40px;
    min-height: 40px;
    min-width: 40px;
    background: ${({ variant }) => (variant === 'light' ? 'var(--light)' : 'var(--btnDarkTxt)')};
    border-radius: 5px;
    margin-right: 12px;
  }
`;

export const InfoBarSvg = styled.object`
  display: block;
  height: 32px;
  width: 32px;
  user-select: none;
  pointer-events: none;
`;

export const InfoTextWrapper = styled.div`
  display: grid;
  align-items: center;
  text-align: center;
  @media (min-width: 768px) {
    text-align: left;
  }
  @media (min-width: 992px) {
    text-align: center;
  }
`;

export const InfoBarLargeText = styled.span`
  color: ${(props) => (props.color ? props.color : 'var(--inputTxtColor)')};
  font-size: 15px;
  font-weight: 500;
  font-family: var(--headingFont);
  margin-right: 4px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
  @media (min-width: 992px) {
    font-size: 18px;
  }
  @media (min-width: 1200px) {
    font-size: 20px;
  }
`;

export const InfoBarText = styled.p`
  color: ${({ variant }) => (variant === 'default' ? '#fff' : 'var(--inputTxtColor)')};
  font-size: 14px;
  line-height: 1.2;
  padding-top: ${(props) => (props.oneTimeOffer ? '0px' : '4px')};
  @media (min-width: 481px) {
    padding-top: unset;
  }
  @media (min-width: 768px) {
    font-size: 15px;
    margin-right: ${(props) => (props.oneTimeOffer ? '0px' : '12px')};
  }
  @media (min-width: 992px) {
    font-size: 16px;
    margin-right: ${(props) => (props.oneTimeOffer ? '0px' : '16px')};
  }
  @media (min-width: 1200px) {
    font-size: 17px;
  }
`;

export const InfoBarTitleText = styled.span`
  color: ${({ variant }) => (variant === 'default' ? '#fff' : 'var(--inputTxtColor)')};
  font-size: 14px;
  font-family: var(--headingFont);
  font-weight: 600;
  line-height: 1.2;
  @media (min-width: 768px) {
    font-size: 15px;
  }
  @media (min-width: 992px) {
    display: block;
    text-align: left;
    font-size: 16px;
  }
  @media (min-width: 1200px) {
    font-size: 17px;
  }
`;

export const InfoBarLink = styled.span`
  color: ${({ variant }) => (variant === 'default' ? '#fff' : 'var(--inputTxtColor)')};
  font-family: var(--headingFont);
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  text-decoration: underline !important;
  text-underline-offset: 2px;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  @media (min-width: 576px) {
    font-size: 15px;
  }
`;

export const InfoBarButton = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: block;
    font-size: 15px;
    font-weight: 500;
    width: 120px;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${({ variant }) => (variant === 'light' ? 'var(--btnDarkTxt)' : '#fff')};
    background: ${({ variant }) => (variant === 'light' ? '#fff' : 'var(--btnDarkTxt)')};
    white-space: nowrap;
    :hover {
      filter: brightness(97%);
    }
    :active {
      filter: unset;
    }
  }
`;

export const InfoBarClose = styled(MdClose)`
  position: absolute;
  z-index: 1;
  top: 1px;
  right: 1px;
  color: ${(props) => (props.color ? props.color : 'var(--normalTxtColor)')};
  font-size: 18px;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  @media (min-width: 992px) {
    font-size: 20px;
  }
`;
// course special offer snackbar ends

export const SignupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 80px auto;
  width: 80%;
  @media (max-width: 1199px) {
    width: 94%;
    flex-direction: column;
  }
  @media (max-width: 600px) {
    margin: 30px 10px;
  }
`;

export const StaticInfoBarOuter = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  padding: 8px;
  padding-right: ${(props) => props.closeIcon && '20px'};
  margin-bottom: 20px;
  border-radius: 4px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ variant, darkTheme }) =>
    variant === 'regionals'
      ? darkTheme
        ? 'var(--regionalsDarkBtn)'
        : 'var(--regionalsDark)'
      : variant === 'partner-plus'
      ? darkTheme
        ? 'var(--partnerDarkBtn)'
        : 'var(--partnerPlusColor)'
      : variant === 'code-juniors'
      ? darkTheme
        ? 'var(--juniorsDarkBtn)'
        : 'var(--codeJuniorsColor)'
      : darkTheme
      ? 'var(--goldenBgDark)'
      : 'var(--goldenBgColor)'};
  box-shadow: 0px 0px 4px var(--greyShadowColor);
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;

export const StaticInfoBarInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin: 0px auto;
  display: grid;
  z-index: 1;
  color: ${({ variant, darkTheme }) => (darkTheme || variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors' ? '#fff' : 'var(--inputTxtColor)')};
  @media (min-width: 576px) {
    grid-template-columns: max-content auto;
    align-items: center;
    justify-content: space-between;
  }
`;

// promo copy bar styles
export const StripedPromoContainer = styled.div`
  z-index: 2000;
  position: ${(props) => (props.checkout ? 'relative' : 'sticky')};
  height: var(--topOfferSnackbarHeight);
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  animation: 1.5s linear 0s 1 ${changeOpacity};
  background-color: ${({ variant }) =>
    variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ variant }) =>
      variant === 'regionals'
        ? 'var(--stripedRegionalsBg)'
        : variant === 'partner-plus'
        ? 'var(--stripedPartnerBg)'
        : variant === 'code-juniors'
        ? 'var(--stripedJuniorsBg)'
        : 'var(--stripedBlueBg)'};
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const BarPromoCode = styled.span`
  position: relative;
  color: ${({ variant }) => (variant === 'regionals' ? 'var(--inputTxtColor)' : 'var(--pricingBarYellow)')};
  border: 1px dashed ${({ variant }) => (variant === 'regionals' ? 'var(--grey)' : 'var(--siteBorderColor)')};
  padding: 0px 4px;
  border-radius: 2px;
  text-wrap: nowrap;
  cursor: pointer;
  &:hover {
    color: var(--warning);
  }
`;
export const BarPromoStatus = styled.span`
  position: absolute;
  top: -39px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--light);
  font-size: 15px;
  width: max-content;
  padding: 4px 8px;
  background-color: #242424ed;
  border-radius: 4px;
  cursor: default;
  z-index: 1;
  @media (min-width: 360px) {
    top: -34px;
  }
`;

// dynamic prime offer card styles
export const DboardPrimeOfferCardOuter = styled.div`
  --dynamicPrimeImgWidth: 140px;
  --offCardXAxisPadding: 8px;
  --staticPrimeSvgWidth: 48px;
  --ctaDivisionSize: 166px;
  --originalsBorderColor: #ffffff8a;
  --juniorsBorderColor: #ffffff5e;
  --othersBorderColor: #ffffff2e;
  padding-bottom: 24px;
  font-size: 14px;
  & .offer-small-text {
    font-size: 13px;
  }
  @media (min-width: 481px) {
    font-size: 15px;
    & .offer-small-text {
      font-size: 14px;
    }
  }
  @media (min-width: 576px) {
    --dynamicPrimeImgWidth: 224px;
    --staticPrimeSvgWidth: 75px;
  }
  @media (min-width: 768px) {
    --dynamicPrimeImgWidth: 176px;
    --offCardXAxisPadding: 12px
    --staticPrimeSvgWidth: 50px;
  }
  @media (min-width: 992px) {
    font-size: 16px;
    & .offer-small-text {
      font-size: 15px;
    }
  }
  @media (min-width: 1200px) {
    --dynamicPrimeImgWidth: 146px;
  }
  @media (min-width: 1800px) {
    --ctaDivisionSize: 172px;
  }
`;

export const DboardPrimeOfferCardLabel = styled.span`
  display: inline-block;
  padding: 3px 8px;
  color: var(--inputTxtColor);
  background: var(--goldenBgColor);
  border-radius: 4px 4px 0px 0px;
  font-size: 14px;
  font-family: var(--headingFont);
  font-weight: 500;
  @media (min-width: 481px) {
    font-size: 15px;
  }
  @media (min-width: 768px) {
    padding: 3px 12px;
  }
`;

export const DboardPrimeOfferCardInner = styled.div`
  color: ${({ variant }) => (variant !== 'originals' ? '#fff' : 'var(--inputTxtColor)')};
  background-color: ${({ variant, darkTheme }) =>
    variant === 'regionals'
      ? darkTheme
        ? 'var(--regionalsDarkBg)'
        : 'var(--regionalsDark)'
      : variant === 'partner-plus'
      ? darkTheme
        ? 'var(--partnerPlusDarkBg)'
        : 'var(--partnerPlusColor)'
      : variant === 'code-juniors'
      ? darkTheme
        ? 'var(--codeJuniorsDarkBg)'
        : 'var(--codeJuniorsColor)'
      : darkTheme
      ? 'var(--yellow)'
      : 'var(--goldenBgColor)'};
  border-radius: ${({ variant }) => (variant !== 'originals' ? '0px 4px 4px 4px' : '4px')};
  overflow: hidden;
  cursor: pointer;
  @media (min-width: 576px) {
    display: grid;
    grid-template-columns: calc(var(--dynamicPrimeImgWidth) + calc(2 * var(--offCardXAxisPadding))) auto;
    align-items: center;
  }
  @media (min-width: 768px) {
    grid-template-columns: ${({ isDynamic }) =>
      isDynamic === 'true'
        ? 'calc(var(--dynamicPrimeImgWidth) + calc(2 * var(--offCardXAxisPadding))) auto'
        : 'calc(var(--staticPrimeSvgWidth) + calc(2 * var(--offCardXAxisPadding))) auto'};
  }
`;

export const DboardPrimeLeftImgWrapper = styled.div`
  display: none;
  @media (min-width: 576px) {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: calc(var(--dynamicPrimeImgWidth) + calc(2 * var(--offCardXAxisPadding)));
    padding: 8px var(--offCardXAxisPadding);
  }
  @media (min-width: 768px) {
  width: ${({ isDynamic }) =>
    isDynamic === 'true' ? 'calc(var(--dynamicPrimeImgWidth) + calc(2 * var(--offCardXAxisPadding)))' : 'calc(var(--staticPrimeSvgWidth) + calc(2 * var(--offCardXAxisPadding)))'}
    padding: 8px var(--offCardXAxisPadding);
  }
`;

export const DboardPrimeOfferCardHead = styled.div`
  border-bottom: 1px solid
    ${({ variant }) => (variant === 'originals' ? 'var(--originalsBorderColor)' : variant === 'code-juniors' ? 'var(--juniorsBorderColor)' : 'var(--othersBorderColor)')};
`;

export const DboardPrimeOfferCardHeadInner = styled.div`
  display: flex;
  justify-content: space-between;
  @media (min-width: 576px) {
    justify-content: center;
  }
  @media (min-width: 768px) {
    justify-content: space-between;
  }
`;

export const PrimeHeadSpan = styled.span`
  width: 100%;
  height: 100%;
  padding: 4px 8px;
  color: #fff;
  background: ${({ variant }) => (variant === 'light' ? 'transparent' : 'var(--btnDarkTxt)')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px 3px;
  border-radius: 4px;
`;

export const PrimeOfferTitleDiv = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: normal;
  font-size: 15px;
  @media (min-width: 481px) {
    font-size: 16px;
  }
  @media (min-width: 768px) {
    padding: 8px 12px;
  }
  @media (min-width: 992px) {
    font-size: 17px;
  }
`;

export const PrimeOfferShineDiv = styled.div`
  position: relative;
  height: 100%;
  padding: 4px 8px;
  color: #fff;
  background: ${({ variant }) => (variant === 'light' ? 'transparent' : 'var(--btnDarkTxt)')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px 3px;
  border-radius: 4px;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    left: -20%;
    width: 24px;
    height: 100%;
    background-color: #ffffff5e;
    filter: blur(12px);
    transform: skewX(-20deg);
    z-index: 0;
    animation: ${offerShine} 4.5s ease-in-out infinite;
  }
`;

export const PrimeOfferTimerDiv = styled.div`
  padding: 12px 0px 0px;
  @media (min-width: 768px) {
    padding: 0px;
  }
  @media (min-width: 1200px) {
    padding: 4px 12px;
  }
`;

export const DboardPrimeRightWrapper = styled.div`
  @media (min-width: 576px) {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-left: 1px solid
      ${({ variant }) => (variant === 'originals' ? 'var(--originalsBorderColor)' : variant === 'code-juniors' ? 'var(--juniorsBorderColor)' : 'var(--othersBorderColor)')};
  }
`;

export const DynamicPrimeOfferCardBody = styled.div`
  flex: 1;
  padding: 12px 8px;
  @media (min-width: 576px) {
    display: grid;
    align-items: center;
  }
  @media (min-width: 768px) {
    padding: 12px;
  }
  @media (min-width: 1200px) {
    grid-template-columns: auto var(--ctaDivisionSize);
  }
`;

export const DynamicPrimeOfferImgWrapper = styled.div`
  width: 100%;
  margin: 0px auto;
  overflow: hidden;
  @media (min-width: 576px) {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--dynamicPrimeImgWidth);
    margin: unset;
  }
  @media (min-width: 768px) {
    width: ${({ isDynamic }) => (isDynamic === 'true' ? 'var(--dynamicPrimeImgWidth)' : 'var(--staticPrimeSvgWidth)')};
  }
`;

export const DboardPrimeOfferSvg = styled.object`
  display: block;
  width: var(--staticPrimeSvgWidth);
  height: var(--staticPrimeSvgWidth);
  margin: 0px auto;
  user-select: none;
  pointer-events: none;
  @media (min-width: 576px) {
    margin: unset;
  }
`;

export const DboardPrimeOfferContentWrapper = styled.div`
  padding-top: 16px;
  text-align: center;
  @media (min-width: 576px) {
    padding-top: unset;
  }
  @media (min-width: 768px) {
    text-align: left;
  }
  @media (min-width: 1200px) {
    text-align: center;
  }
`;

export const DboardPrimeOfferButton = styled.button`
  width: 100%;
  max-width: 220px;
  margin: 0px auto;
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: ${({ variant }) => (variant === 'light' ? 'var(--btnDarkTxt)' : '#fff')};
  background: ${({ variant }) => (variant === 'light' ? '#fff' : 'var(--btnDarkTxt)')};
  padding: 8px 16px;
  border-radius: 4px;
  white-space: nowrap;
  :hover {
    filter: brightness(97%);
  }
  :active {
    filter: unset;
  }
  @media (min-width: 768px) {
    width: 150px;
    margin: unset;
  }
  @media (min-width: 1800px) {
    width: 156px;
  }
`;
